// extracted by mini-css-extract-plugin
export default {"project":"Project_project__Zb55r","project__body":"Project_project__body__zjQ4J","project__cards":"Project_project__cards__b0spV"};